import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography, Link } from '@albo-ui/core';
import { List, ListItem, Box } from "@mui/material";
import { styled } from '@mui/material/styles';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import cardImage from "../../../images/card_new.png";

export type InfoCardDialogProps = {
    onClose: () => void;
    open: boolean;
    title: string;
    message: string;
    data: any;
    type: string;
} & DefaultComponentProps;

const FireNav = styled(List)({
  '& .MuiListItem-root': {padding: 0},
  '& .MuiSvgIcon-root': {fontSize: 20, marginRight: 16 },
});

export const InfoCard = ({ open, title, message, data, type, onClose }: InfoCardDialogProps) => {
    const openLink = (url) => {
        window.open(url, "_blank");
    }
    const copy = (data) => {
        navigator.clipboard.writeText(data);
    };

    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>
                <FlexGrid container direction='column'>
                    <Typography variant='h2'>{title}</Typography>
                    {type === 'tracking' && <Typography variant='paragraph' style={{paddingTop: -15}}>{message}</Typography>}
                </FlexGrid>
            </DialogTitle>
  
            <DialogContent>
                {type === 'cards' && 
                    <FlexGrid container fullWidth style={{marginTop: 15}}>
                        <FlexGrid fullWidth>
                            <Box component="img" alt="logo" src={cardImage} width={176}/>
                        </FlexGrid>
                        <FlexGrid container item fullWidth direction='column' style={{fontSize: 20}}>
                            <Typography variant='paragraph' style={{ fontSize: 16, color: "green" }}>Tarjetas activadas</Typography> 
                            <Typography variant='paragraph' bold style={{ fontSize: 16, marginTop: 10 }}>{data.result.assigned}</Typography> 

							<Typography variant='paragraph' style={{ fontSize: 16, color: "red", marginTop: "25px" }}>Tarjetas por activar</Typography>							
                            <Typography variant='paragraph' bold style={{ fontSize: 16, marginTop: 10 }}>{data.result.unassigned}</Typography> 
							
                        </FlexGrid>
                    </FlexGrid>

                }
                {type === 'tracking' && 
                    <FlexGrid fullWidth>
                        <FireNav disablePadding>
                            <List style={{marginTop: 10}}>
                            {data.row.tracking.length > 0 && data.row.tracking.map((item, index) => {
                                return (
                                    <ListItem key={index}>
                                        <Link key={index} onClick={() => openLink(item.tracking_url)} underlined style={{fontSize: "18px"}}>
                                            {item.tracking_number}
                                        </Link>
                                        <FileCopyOutlinedIcon titleAccess={`Copiar`} sx={{ml: 2}} color='primary' onClick={copy.bind(this, item.tracking_number)} cursor={"pointer"} />
                                    </ListItem>
                                )
                            })}
                            </List>
                        </FireNav>
                    </FlexGrid>
                }
            </DialogContent>

            <DialogActions>
                <FlexGrid fullHeight alignItems='flex-end' >
                    <Button onClick={onClose} buttonType='primary' size='normal' style={{width: 150}}>
                        Cerrar
                    </Button>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}